/** @module store/datetimepicker */
import moment from 'moment'
/**
 * Store state for current `datetimepicker`.
 *
 * @function
 *
 * @return {object}
 */

const keyMapping = {
  dateFrom: 'date_from',
  dateMonth: 'date_month',
  dateTo: 'date_to',
  dateYear: 'date_year',
  period: 'period',
  tz: 'tz'
}

const state = () => ({
  dateFrom: null,
  dateMonth: null,
  dateTo: moment().utc().format(),
  dateYear: null,
  period: 'week',
  tz: null
})

const getters = {
  getTFilter: (state) => {
    const res = {}
    for (const key in state) {
      if (state[key] && key !== 'tz') {
        res[key] = state[key]
      }
    }
    return res
  },
  getTz: (state) => {
    return state.tz
  },
  datetimeFilter: (state) => {
    return state
  },
  datetimeIsPicked: (state) => {
    for (const key in state) {
      if (state[key]) {
        return true
      }
    }
    return false
  }
}

const mutations = {
  SET_DATETIME_CHOICE(state, choice) {
    for (const key in state) {
      state[key] = choice[keyMapping[key]]
    }
  },
  DELETE_STATE(state) {
    for (const key in state) {
      state[key] = null
    }
  },
  SET_FROM_DATETIMEPICKER(state, selects) {
    for (const key in state) {
      state[key] = null
    }

    if (selects.tz) {
      state.tz = selects.tz
    }

    switch (selects.type) {
      case '24hours':
        state.period = 'day'
        state.dateTo = moment(selects.date).utc().format()
        break
      case '7days':
        state.period = 'week'
        state.dateTo = moment(selects.date).utc().format()
        break
      case '30days':
        state.period = 'month'
        state.dateTo = moment(selects.date).utc().format()
        break
      case '12months':
        state.period = 'year'
        state.dateTo = moment(selects.date).utc().format()
        break
      case 'ever':
        state.period = 'ever'
        state.dateTo = moment(selects.date).utc().format()
        break
      case 'week':
        state.dateFrom = moment(selects.date[0]).utc().format()
        state.dateTo = moment(selects.date[1]).utc().format()
        break
      case 'month':
        state.period = 'month'
        state.dateFrom = moment(selects.date).utc().format()
        break
      case 'range':
        state.dateFrom = moment(selects.date[0]).utc().format()
        state.dateTo = moment(selects.date[1]).utc().format()
        break
    }
  }
}

/**
 * Allows to subscribe to legacy datetime-picker change events.
 *
 * @function
 *
 * @param {object} params
 * @param {function} params.cb is a callback function called for each subsciption event. It is called with the Vuex context object `context` of this store and the `event` object.
 *
 */
async function subscribeToLegacyDatetimepicker(context, { cb }) {
  document.addEventListener(
    'datetime',
    function (e) {
      cb(context, e)
    },
    false
  )
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    subscribeToLegacyDatetimepicker
  }
}
